import { RouteObject } from 'react-router-dom';
import vendorAuthRoutes from './auth';
import vendorDashboardRoutes from './dashboard';

export const vendorRoutes: RouteObject[] = [
  ...vendorDashboardRoutes,
  ...vendorAuthRoutes,
];
